import { useNaviProduct } from "../../hooks/useNaviProduct";
import { mergeClass } from "../../utils/common";
import CdnImage from "../image/CdnImage";
import Icon from "../image/Icon";
import { icPremiumPlusTag } from "../image/image-src";
import { TicketBoxBottom } from "./CardBottom";

export const TicketBox = ({
  product,
  className,
  cdnParams,
}: {
  product: ProductBaseResponse;
  className?: string;
  cdnParams?: CdnParam;
}) => {
  const { naviProduct } = useNaviProduct();
  const imageUrl = product.thumbnailHome
    ? product.thumbnailHome
    : product.thumbnail;

  return (
    <div
      role="button"
      onClick={() => naviProduct(product)}
      className={mergeClass(
        "ticket-box relative flex flex-col items-start rounded-2xl bg-cover bg-center text-center",
        className,
      )}
    >
      {/* Background image */}
      <CdnImage
        src={imageUrl}
        alt={product.name || "ticket"}
        className="absolute inset-0 z-0 h-full w-full rounded-2xl object-cover"
        draggable={false}
        cdnParams={
          cdnParams ?? {
            format: "webp",
            width: 360,
            height: 500,
            fit: "cover",
            quality: 70,
          }
        }
        loading="lazy"
      />
      {!!product.premiumPlusPrice && (
        <span className="absolute right-[0.5rem] top-[0.5rem] z-[2]">
          <Icon src={icPremiumPlusTag} />
        </span>
      )}
      {/* Overlay for readability */}
      <div
        className="absolute inset-0 z-10 overflow-hidden rounded-2xl"
        style={{
          background:
            "linear-gradient(180deg, rgba(0, 0, 0, 0) 42.05%, rgba(0, 0, 0, 0.6) 100%)",
        }}
      >
        <TicketBoxBottom product={product} />
      </div>
    </div>
  );
};
